var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import Loading02Svg from './loading-02.icon.svg';
export const Loading02Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: Loading02Svg }));
_react_refresh_temp_1 = Loading02Icon;
$RefreshReg$(_react_refresh_temp_1, "Loading02Icon");
